import { makeRequest } from "../utils/axios.js"; 

const upload = async (file) => {
    try {
        const formData = new FormData();

        if (Array.isArray(file)) {
            file.forEach((f) => {
                formData.append("files", f); 
            });
        } 
        else {
            formData.append("files", file);
        }

        const res = await makeRequest.post("/upload", formData);

        return res.data; 

    } catch (err) {
        console.error("Upload failed:", err);
        throw err;
    }
};

export default upload;